import { API } from '../../config';
import { getLanguage } from '../../language';

class Base {
  constructor(entity, initialState) {
    this.baseUrl = API;
    this.initialState = initialState;
    this.GET = `${entity}/GET`;
    this.FETCH = `${entity}/FETCH`;

    this.defaultHeaders = {
      'Content-Type': 'application/json',
      'X-Skip-Subdomain-Redirect': 'true'
    };
  }

  headers() {
    return { ...this.defaultHeaders };
  }

  reducer(state = this.initialState, action = {}) {
    const withInitialState = {
      ...state,
      initialState: this.initialState
    };
    switch (action.type) {
      case this.GET: {
        const defaultValues = state.isSingleObject ? {} : [];
        const data = {
          ...withInitialState,
          values: action.data || defaultValues,
          isFetching: false
        };
        return data;
      }
      case this.FETCH: {
        return {
          ...withInitialState,
          isFetching: true,
          values: state.isSingleObject ? {} : []
        };
      }
      default: {
        return withInitialState;
      }
    }
  }

  get(data) {
    return {
      type: this.GET,
      data
    };
  }

  fetch() {
    return {
      type: this.FETCH
    };
  }

  getAsync(url) {
    return (dispatch) => {
      dispatch(this.fetch());

      const options = {
        method: 'GET',
        headers: this.headers()
      };

      const language = getLanguage();

      return fetch(`${this.baseUrl}/${url}?language=${language}`, options)
        .then((response) => {
          if (response.status > 400) {
            return false;
          }
          return response.json();
        })
        .then((response) => {
          dispatch(this.get(response));
          return response;
        })
        .catch((e) => {
          throw e;
        });
    };
  }
}

export default Base;



// WEBPACK FOOTER //
// ./src/redux/modules/Base.js